var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var NotEnoughColumnsError = /** @class */ (function (_super) {
    __extends(NotEnoughColumnsError, _super);
    function NotEnoughColumnsError(expectedColumnsCount, actualColumnsCount, rowPos) {
        var _this = _super.call(this, "CSV row has ".concat(actualColumnsCount, " values in a row #").concat(rowPos, ", when expected ").concat(expectedColumnsCount, " values")) || this;
        _this.expectedColumnsCount = expectedColumnsCount;
        _this.actualColumnsCount = actualColumnsCount;
        _this.rowPos = rowPos;
        return _this;
    }
    return NotEnoughColumnsError;
}(Error));
export { NotEnoughColumnsError };
//# sourceMappingURL=NotEnoughColumnsError.js.map